var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_1629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3952 15.1277C19.1707 15.1277 17.9684 14.9362 16.8291 14.5597C16.2708 14.3693 15.5845 14.544 15.2438 14.8939L12.995 16.5915C10.387 15.1994 8.78057 13.5934 7.40745 11.0051L9.0551 8.81484C9.48318 8.38734 9.63672 7.76286 9.45276 7.17693C9.07464 6.03161 8.88255 4.8299 8.88255 3.6049C8.8826 2.71995 8.16266 2 7.27776 2H3.60484C2.71995 2 2 2.71995 2 3.60484C2 13.7481 10.252 22 20.3952 22C21.2801 22 22.0001 21.2801 22.0001 20.3952V16.7325C22 15.8477 21.2801 15.1277 20.3952 15.1277Z",
    fill: "#7DC82F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_1629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneInput);
export default __webpack_public_path__ + "static/media/phoneInput.e3f53ba14a81bba4d0b9e29e2846c591.svg";
export { ForwardRef as ReactComponent };